export const config = {
  title: "Jonathan Citron | Keller Williams Premier Properties - Summit, NJ",
  meta: {
    description:
      "Helping clients buy and sell homes in Summit, NJ and surrounding communities with top-tier service and expert guidance.",
    keywords: [
      "Jonathan Citron real estate",
      "Keller Williams Premier Properties Summit NJ",
      "homes for sale Summit NJ",
      "buying a home Summit NJ",
      "selling property Summit NJ"
    ],
    author: "Jonathan Citron Keller Williams Premier Properties",
    canonicalUrl: "https://www.jonathancitronhomes.com/",
  },
  sections: {
    header: {
      businessName: "Jonathan Citron | Keller Williams Premier Properties",
    },
    sectionB: {
      heroTitle: "Jonathan Citron",
      heroSubtitle: "Keller Williams Premier Properties – Your Trusted Realtor in Summit, NJ",
      learnAboutText: "Explore Listings",
      phoneNumber: "9737277095",
      phoneLabel: "(973) 727-7095",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/2181067644/photo/aerial-drone-view-of-brick-veneer-town-houses-in-melbourne-northern-suburb-victoria-australian.jpg?s=612x612&w=0&k=20&c=WmtelVadMl2SH6HZyHM8T1L-29ZyhWjTbRyk_NCyDWs=",
      cardData: [
        {
          title: "Residential Sales",
          description: "Buying or selling your home? I provide expert local market guidance.",
        },
        {
          title: "Luxury Properties",
          description: "Access high-end listings and exclusive property deals in New Jersey.",
        },
        {
          title: "Client-Focused Strategy",
          description: "Real estate services tailored to your unique goals and timeline.",
        },
      ],
      description:
        "With Keller Williams Premier Properties, Jonathan Citron offers real estate services built on trust, knowledge, and dedication to client success. Serving Summit, NJ and nearby areas.",
    },
    sectionC: {
      servicesTitle: "Real Estate Services",
      servicesDescription:
        "From your first showing to the final closing, I’m with you every step of the way.",
      cards: [
        {
          title: "Home Buying",
          description: "Guidance and negotiation to secure your dream home.",
          imageSrc: "https://media.istockphoto.com/id/1393890856/photo/real-estate-agent-giving-the-keys-of-his-new-house-to-a-man.jpg?s=612x612&w=0&k=20&c=qsWuH9hDYdWuB2T8C5i3k-ewVpJB1zMjA_Z2Zxglcc8=",
          imageAlt: "Home Buying",
        },
        {
          title: "Home Selling",
          description: "Marketing strategies that get your property sold faster.",
          imageSrc: "https://media.istockphoto.com/id/2202196797/photo/loving-couple-organizing-their-home-finances.jpg?s=612x612&w=0&k=20&c=P0oca6gM4oJ1KgGweyi7KvPn3h98XMylBCWguemWmTU=",
          imageAlt: "Home Selling",
        },
        {
          title: "Market Analysis",
          description: "Understand your property’s value and local trends.",
          imageSrc: "https://media.istockphoto.com/id/2153366114/photo/real-estate-agent-discussion-to-explaining-about-property-investment-document-with-home-sales.jpg?s=612x612&w=0&k=20&c=AR0OndPnl4cak0JuunNCGImT9Vzbs6AtazAXXmfZO0Q=",
          imageAlt: "Market Analysis",
        },
      ],
      otherServicesTitle: "Why Work With Jonathan?",
      otherServicesList: [
        "Local Market Expertise",
        "Responsive & Transparent Communication",
        "Full-Service Real Estate Support",
        "Trusted Keller Williams Network",
        "Client-First Philosophy",
      ],
    },
    sectionD: {
      aboutTitle: "Meet Jonathan Citron",
      aboutImage: {
        src: "https://www.jonathancitronhomes.com/wp-content/uploads/sites/25161/2025/09/Jonathan-Citron-300x300.png",
        alt: "Jonathan Citron",
      },
      aboutText: [
        "Jonathan Citron is a dedicated real estate agent with Keller Williams Premier Properties, helping clients buy and sell homes in Summit, NJ and surrounding neighborhoods.",
        "Jonathan combines market insight, strong negotiation skills, and a commitment to excellence to make every real estate transaction smooth and successful.",
      ],
    },
    sectionE: {
      profileImage: "https://www.jonathancitronhomes.com/wp-content/uploads/sites/25161/2022/06/equal-housing-opportunity-logo-png-transparent-copy.png",
      profileAlt: "Jonathan Citron Profile",
      businessName: "Jonathan Citron Keller Williams Premier Properties",
      contact: {
        phone: "9737277095",
        phoneLabel: "(973) 727-7095",
        email: "jcitron@kw.com",
        website: "https://www.jonathancitronhomes.com/",
        address: "488 Springfield Avenue, Summit, NJ 07901",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "488 Springfield Avenue, Summit, NJ 07901, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps?q=488+Springfield+Avenue,+Summit,+NJ+07901&output=embed",
    },
  },
};

export default config;
